import {rootAction} from "../apiAction";

export const REQUEST_GET_BACKEND_BUILD = 'REQUEST_GET_BACKEND_BUILD';
export const SUCCESS_GET_BACKEND_BUILD = 'SUCCESS_GET_BACKEND_BUILD';
export const FAILURE_GET_BACKEND_BUILD = 'FAILURE_GET_BACKEND_BUILD';

export const getBackInfo = () => dispatch => {
    return dispatch(rootAction(
        'GET',
        `/health/ping`,
        null,
        {
            request: REQUEST_GET_BACKEND_BUILD,
            success: SUCCESS_GET_BACKEND_BUILD,
            failure: FAILURE_GET_BACKEND_BUILD
        }
    ));
}

